// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "._2SF9Jl9mUVdq96AMCT8n6b {\n  text-align: center;\n}\n", "",{"version":3,"sources":["Betting.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF","file":"Betting.css","sourcesContent":[".form {\n  text-align: center;\n}\n"]}]);
// Exports
exports.locals = {
	"form": "_2SF9Jl9mUVdq96AMCT8n6b"
};
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader/dist/cjs.js??ref--1-1!../node_modules/postcss-loader??ref--1-2!./components/Betting/Betting.css
// module id = 570
// module chunks = 37